export default __webpack_public_path__ + "static/media/grunwelcomeimg.1ac325e3.png";